import { IFormattedAssetItem, useMutation } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';
import { IAddDeleteImageToEvaluationPayload } from '../../../types';

/**
 * This is to track the add or delete media to evaluation mutation keys in react
 * query cache.
 */
const ADD_OR_DELETE_MEDIA_TO_EVALUATION_MUTATION_KEY =
  'add-or-delete-media-to-evaluation-mutation-key';

interface IUseManageCreateOrUpdateMutation {
  onSuccessCallback?: (
    data: IFormattedAssetItem,
    payload: IAddDeleteImageToEvaluationPayload
  ) => void;
}

/**
 * React Query mutation function for adding or deleting media to/from an
 * evaluation.
 */
export const useAddOrDeleteMediaToEvaluation = ({
  onSuccessCallback,
}: IUseManageCreateOrUpdateMutation) => {
  const {
    data,
    error,
    isError,
    isPending,
    mutate: addOrDeleteMediaToEvaluation,
    reset: resetAddOrDeleteMediaToEvaluation,
  } = useMutation({
    mutationKey: [ADD_OR_DELETE_MEDIA_TO_EVALUATION_MUTATION_KEY],
    networkMode: 'always',
    mutationFn: INBOUND_API.addOrDeleteMediaToEvaluation,
    onSuccess: onSuccessCallback,
  });

  return {
    addOrDeleteMediaToEvaluation,
    data,
    error,
    isError,
    isPending,
    resetAddOrDeleteMediaToEvaluation,
  };
};
